import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { PassFacadeService } from "./pass-facade.service";
import { Pass } from "../../models/pass.model";

@Injectable({ providedIn: "root" })
export class PassStoreService extends EntityStoreService<
  Pass,
  EntityMetadata,
  PassState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      currentPassId: null,
    });
  }
}

export interface PassState extends EntityStoreState<PassFacadeService> {
  currentPassId: string;
}
